<script setup lang="ts">
import { getGlobalTranslation } from '~/js/composables/translations'

import ButtonPrimary from '~/vue/__fiftyfiveplus/_atoms/buttons/ButtonPrimary.vue'
import ButtonTertiary from '~/vue/__fiftyfiveplus/_atoms/buttons/ButtonTertiary.vue'

interface Props {
    utilities?: string
}

const props = withDefaults(defineProps<Props>(), {
    utilities: ''
})
</script>

<template>
    <div
        :class="[
            'flex flex-col relative overflow-hidden gap-4',
            'bg-off-white',
            'rounded-2xl',
            'border-4 border-dark-burgundy',
            'transition-all',
            'group',
            'animate-pulse',
        ]"
    >
        <div class="w-full aspect-video">
            <div class="bg-gray-300 w-full h-full" />
        </div>
        <div class="w-full aspect-video">
            <div class="bg-transparent w-full h-full" />
        </div>
        <ButtonTertiary
            type="button"
            icon="fa-solid fa-chevron-right"
            iconPosition="after"
            :content="getGlobalTranslation('Leer meer')"
            utilities="ml-auto pb-4"
        />
    </div>
</template>